import { Box, BoxProps, Heading, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ERoutes } from "Router/types";
import { ISearch } from "types";
import { SearchHeading } from "./SearchHeading";

interface Props extends BoxProps {
  documents: ISearch["documents"];
}

export const Documents = ({ documents, ...boxProps }: Props) => {
  const { t } = useTranslation();
  if (documents.length === 0) return null;
  return (
    <Box {...boxProps}>
      <SearchHeading>{t("Documents")}</SearchHeading>
      {documents.map((document) => (
        <LinkBox key={document.documentId} _hover={{ bg: "gray.200" }} px="1" py="2">
          <Text fontWeight="semibold">
            <LinkOverlay as={Link} to={`${ERoutes.supplier}/${document.companyId}/documents`}>
              {document.documentTitle}
            </LinkOverlay>
          </Text>
          <Text fontSize="small">{document.companyName}</Text>
        </LinkBox>
      ))}
    </Box>
  );
};
